import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Input, Logo } from '../../design-system';
import { ApiError } from '../../lib/apiClient';
import { useAuth } from './useAuth';
import koning from './koning-wagenpark.png';
import styles from './LoginPage.module.css';

// Easter egg: dubbelklik op het logo → "Koning Wagenpark"-modus (puur decoratief).
const COINS = [
  styles.coinHero,
  styles.coin1,
  styles.coin2,
  styles.coin3,
  styles.coin4,
  styles.coin5,
];
const SPARKLES = [
  { e: '👑', top: '7%', left: '30%', size: 52, delay: '0s' },
  { e: '💰', top: '15%', left: '78%', size: 44, delay: '0.4s' },
  { e: '💎', top: '35%', left: '4%', size: 40, delay: '0.8s' },
  { e: '🤑', top: '62%', left: '84%', size: 48, delay: '0.2s' },
  { e: '🪙', top: '80%', left: '22%', size: 46, delay: '1.1s' },
  { e: '✨', top: '48%', left: '48%', size: 38, delay: '0.6s' },
  { e: '💸', top: '88%', left: '60%', size: 44, delay: '0.9s' },
  { e: '👑', top: '28%', left: '92%', size: 40, delay: '1.4s' },
  { e: '💍', top: '70%', left: '6%', size: 42, delay: '0.3s' },
];

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [bling, setBling] = useState(false);

  /** ProtectedRoute geeft mee waar de sessie sneuvelde; daar keren we naar terug. */
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login({ email, password });
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Er ging iets mis');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={`${styles.screen} ${bling ? styles.screenBling : ''}`}>
      {bling && (
        <div className={styles.blingLayer} aria-hidden="true">
          {COINS.map((c, i) => (
            <img key={i} src={koning} alt="" className={`${styles.coin} ${c}`} />
          ))}
          {SPARKLES.map((s, i) => (
            <span
              key={i}
              className={styles.sparkle}
              style={{ top: s.top, left: s.left, fontSize: s.size, animationDelay: s.delay }}
            >
              {s.e}
            </span>
          ))}
        </div>
      )}
      <div className={`${styles.card} ${bling ? styles.cardBling : ''}`}>
        <span
          className={styles.logoHit}
          onDoubleClick={() => setBling((b) => !b)}
          role="button"
          tabIndex={-1}
          aria-label="Veerenstael"
        >
          <Logo height={36} />
        </span>
        <div>
          <div className={styles.eyebrow}>Wagenpark</div>
          <div className={styles.rule} />
          <h1 className={`${styles.title} ${bling ? styles.titleBling : ''}`}>
            {bling ? '👑 Koning Wagenpark 👑' : 'Basis op orde.'}
          </h1>
          <p className={styles.sub}>Log in om het wagenparkoverzicht te openen.</p>
        </div>
        <form className={styles.form} onSubmit={onSubmit}>
          <Input
            label="E-mailadres"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="naam@veerenstael.nl"
            required
          />
          <Input
            label="Wachtwoord"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
          {error && <div className={styles.error}>{error}</div>}
          <Button variant="primary" block type="submit" disabled={busy}>
            {busy ? 'Bezig…' : 'Inloggen'}
          </Button>
        </form>
      </div>
    </div>
  );
}
